import type { StoreTaxSettings } from "@hobbyshopify/backend-client";
import { Rx } from "subtree.js/core";
import { type FormStatus, idleForm, idleLoad, type LoadStatus } from "../../../../core/primitives/load-status";

export class SalesTaxSectionState {
  readonly settings = new Rx<StoreTaxSettings | null>(null);
  /** The first read; later refreshes show as `fetching` over the last answer. */
  readonly status = new Rx<LoadStatus>(idleLoad);
  readonly fetching = new Rx(false);
  /** When the settings were last read, ms since the epoch; null before the first answer. */
  readonly checkedAt = new Rx<number | null>(null);
  readonly form = new Rx<FormStatus>(idleForm);
}

export abstract class SalesTaxSectionActions {
  /** Re-asks Stripe and rewrites the cache the checkout prices by. */
  abstract refresh(): Promise<void>;
  abstract toggle(): Promise<void>;
}
